import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { TableColumn } from "../../../models/table-columns";
import { SystemMessage } from "../../../models/system-messages.model";
import { AccountService } from "../../../services/account.service";
import { ScrBaseComponent } from "../../base.component";
import { CacheService } from "src/app/services/cache.service";
import { BadgeData } from "src/app/models/badge.model";
import { BADGECOUNTS } from "src/app/shared/constants";

@Component({
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})

export class MessagesComponent extends ScrBaseComponent implements OnInit {
  systemMessages: SystemMessage[] = [];
  selectedMessages: SystemMessage[] = [];
  allSelected = false;

  tableColumn: TableColumn[] = [
    { field: 'messageType', sort: true },
    { field: 'subject', sort: true },
    { field: 'createTime', sort: true }
  ];

  constructor(private accountService: AccountService,
    private confirmationService: ConfirmationService,
    private cacheService: CacheService
  ) {
    super();
   }

  ngOnInit() {
    this.localizeTableColumns(this.tableColumn);
    this.fetchMessages();
  }

  fetchMessages() {
    this.observe(this.accountService.fetchMessages(), res => {
      this.systemMessages = res.systemMessages || [];
      this.selectedMessages = [];
      if (res.count !== undefined) {
        const data = this.cacheService.get<BadgeData>(BADGECOUNTS);
        if (data) {
          data.unreadMessageCount = res.count;
          this.cacheService.set(BADGECOUNTS, data);
        }
      }
      return false;  // don't display the success message.
    });
  }

  deleteSelectedMessages($event: MouseEvent) {
    $event.preventDefault();
    const messageIds = this.selectedMessages.map(item => item.messageId);
    if (messageIds.length > 0) {
      this.confirmationService.confirm({
        key: 'confirmDelete',
        header: 'Delete Confirmation',
        message: 'Do you want to delete this(these) message(s)?',
        accept: () => {
          this.observe(this.accountService.deleteMessages(messageIds), () => {
            this.fetchMessages();
          });
        }
      });
    }
  }

  onSubjectClick($event: Event, message: SystemMessage) {
    $event.preventDefault();
    if (!message.readByUser && message.messageId) {
      this.observe(this.accountService.readMessage(message.messageId), res => {
        message.readByUser = true;

        if (res.count !== undefined) {
          const data = this.cacheService.get<BadgeData>(BADGECOUNTS);
          if (data) {
            data.unreadMessageCount = res.count;
            this.cacheService.set(BADGECOUNTS, data);
          }
        }
        return false;  // don't display the success message.
      });
    }
    message.expanded = !message.expanded;
  }
}
